import React from "react"
import { injectIntl } from "react-intl"
import Toggle from "react-toggle"
import ToggleTooltipComponent from "./ToggleTooltipComponent"

type OwnProps = {
    checked: boolean,
    featureKey: string,
    onFeatureToggled: (featureKey: string) => void,
    renderFeatureLabel: (featureKey: string) => JSX.Element,
    disabled: boolean,
    tooltip?: string
    displayTooltip?: boolean
}

const FeatureToggleComponent = (props: OwnProps) => {
    const toggleProps = {
        id: props.featureKey,
        defaultChecked: props.checked,
        icons: false,
        onChange: () => props.onFeatureToggled(props.featureKey),
        disabled: props.disabled
    }

    return <div className="form-group row" key={props.featureKey}>
        <label className="col-3 col-form-label text-align-right" htmlFor={props.featureKey}>
            {props.renderFeatureLabel(props.featureKey)}
        </label>
        <div className="col-9 d-flex align-items-center">
            { props.displayTooltip
                ? <>
                    <span data-tip data-for={"toggleTooltip-anchor" + props.featureKey}>
                        <Toggle {...toggleProps} />
                    </span>
                    <ToggleTooltipComponent 
                        featureKey={props.featureKey} 
                        message={props.tooltip || ""} />
                </>
                : <Toggle {...toggleProps} />
            }
        </div>
    </div>
}

export default injectIntl(FeatureToggleComponent)


// WEBPACK FOOTER //
// ./src/integration/form/FeatureToggleComponent.tsx